export default function message({
  messageContent = '',
  level = 'information',
}: { messageContent?: string; level?: string } = {}) {
  const iconType = level === 'danger' ? 'warning' : level;
  return `<div class="c-message c-message--${level}">
            <i class="icon icon-${iconType}"></i>
            <div class="c-message__text">
              ${messageContent}
            </div>
          </div>`;
}
